module.exports = {"date":"Date","temperature":"Temperature"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/linechart.json
// module id = QpKz
// module chunks = 2